import EditorSkeleton from '../../../rich-text/Editor/skeleton';
import ToolbarButtonSkeleton from '../../../rich-text/ToolbarButton/skeleton';
import { RichTextEditorProps } from './types';

export interface RichTextEditorSkeletonProps
  extends Pick<RichTextEditorProps, 'toolbar' | 'children' | 'className' | 'classes'> {
  canUploadAttachment?: boolean;
}

const RichTextEditorSkeleton = ({ toolbar, canUploadAttachment, children, ...props }: RichTextEditorSkeletonProps) => {
  if (toolbar === false) {
    return (
      <EditorSkeleton {...props} toolbar={toolbar}>
        {children}
      </EditorSkeleton>
    );
  }

  return (
    <EditorSkeleton
      {...props}
      toolbar={{
        canFormatText: true,
        canInsertFormula: true,
        canUploadImage: true,
        ...toolbar,
        children: canUploadAttachment ? <ToolbarButtonSkeleton /> : null,
      }}
    >
      {children}
    </EditorSkeleton>
  );
};

export default RichTextEditorSkeleton;
